import { useState, useEffect } from "react"; // Added useEffect
import { Box, Grid, Typography, Link, List, ListItem, Divider } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import coursesDB from "../database/ResourceProducts"; // Import the database

const Resources = () => {
  const [draggedOverIndex, setDraggedOverIndex] = useState(null);

  // Auto-scroll to top on component mount
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleDragEnter = (index) => {
    setDraggedOverIndex(index);
  };

  const handleDragLeave = () => {
    setDraggedOverIndex(null);
  };

  return (
    <Box sx={{ 
      padding: { xs: 4, md: 8 }, 
      background: 'linear-gradient(135deg, #f5f7fa, #c3cfe2)', // Gradient background
      minHeight: '100vh',
      fontFamily: '"Montserrat", sans-serif', // Modern font
    }}>
      {/* Header */}
      <Typography variant="h3" sx={{ 
        fontWeight: 700, 
        mb: 6,
        color: '#2c3e50',
        textAlign: 'center',
        fontSize: { xs: '2rem', md: '2.5rem' },
        fontFamily: '"Montserrat", sans-serif', // Consistent font
        textTransform: 'uppercase',
        letterSpacing: '2px',
        position: 'relative',
        '&:after': {
          content: '""',
          position: 'absolute',
          bottom: -10,
          left: '50%',
          transform: 'translateX(-50%)',
          width: '60px',
          height: '4px',
          backgroundColor: '#3498db',
          borderRadius: '2px'
        }
      }}>
        Mega Resources Collection
      </Typography>

      {/* Resources List */}
      <Grid container spacing={4} justifyContent="center">
        {coursesDB.map((category, index) => (
          <Grid item xs={12} md={6} key={index}>
            <Box
              sx={{
                backgroundColor: '#ffffff',
                borderRadius: 4,
                boxShadow: '0 8px 16px rgba(0, 0, 0, 0.1)',
                overflow: 'hidden',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-5px)',
                  boxShadow: '0 12px 24px rgba(0, 0, 0, 0.2)',
                },
              }}
            >
              {/* Category Header */}
              <Box
                sx={{
                  background: 'linear-gradient(45deg, #2c3e50, #3498db)',
                  padding: 2,
                  textAlign: 'center',
                }}
              >
                <Typography variant="h5" sx={{ 
                  fontWeight: 600, 
                  color: '#ffffff',
                  textTransform: 'uppercase',
                  letterSpacing: '1px',
                  fontFamily: '"Montserrat", sans-serif', // Consistent font
                }}>
                  {category.category}
                </Typography>
              </Box>

              {/* Resources List */}
              <List sx={{ width: '100%', padding: 0 }}>
                {category.courses.map((course, idx) => (
                  <div key={course.link}>
                    <ListItem 
                      sx={{ 
                        padding: 2,
                        transition: 'all 0.3s ease',
                        backgroundColor: draggedOverIndex === idx ? '#f0f0f0' : 'inherit',
                        '&:hover': {
                          backgroundColor: '#f8f9fa',
                        }
                      }}
                      onDragEnter={() => handleDragEnter(idx)}
                      onDragLeave={handleDragLeave}
                    >
                      <Link
                        component={RouterLink}
                        to={course.link}
                        sx={{
                          width: '100%',
                          textDecoration: 'none',
                          '&:hover': {
                            textDecoration: 'underline',
                          }
                        }}
                      >
                        <Typography variant="h6" sx={{
                          fontWeight: 500,
                          color: 'text.primary',
                          lineHeight: 1.6,
                          fontSize: '1.1rem',
                          display: 'flex',
                          alignItems: 'center',
                          gap: 2,
                          fontFamily: '"Montserrat", sans-serif', // Consistent font
                        }}>
                          {/* Attractive Bullet */}
                          <Box
                            sx={{
                              width: 12,
                              height: 12,
                              backgroundColor: 'primary.main',
                              borderRadius: '50%',
                              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                            }}
                          />
                          {course.name}
                        </Typography>
                      </Link>
                    </ListItem>
                    {idx < category.courses.length - 1 && <Divider sx={{ my: 1 }} />}
                  </div>
                ))}
              </List>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Resources;